import React from "react";
import { Link } from "react-router-dom";
import { Layout } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { image } from "../data/homeContent";

const { Footer: AntFooter } = Layout;

const Footer = () => {
  const handleSubscribe = (e) => {
    e.preventDefault();
    // Add your subscribe logic here
  };

  return (
    <AntFooter className="!bg-gradient-to-b !from-gray-900 !to-gray-800 !text-gray-200 !p-0 relative overflow-hidden">
      {/* Decorative Shapes */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Large Circle */}
        <div className="absolute -top-20 -right-20 w-40 h-40 bg-blue-500/10 rounded-full blur-xl"></div>

        {/* Medium Circle */}
        <div className="absolute top-32 left-10 w-24 h-24 bg-indigo-500/10 rounded-full blur-lg"></div>

        {/* Small Circle */}
        <div className="absolute bottom-20 right-32 w-16 h-16 bg-purple-500/10 rounded-full blur-md"></div>

        {/* Triangle 1 */}
        <div className="absolute top-16 right-1/3 w-0 h-0 border-l-[20px] border-r-[20px] border-b-[35px] border-l-transparent border-r-transparent border-b-blue-500/10 blur-sm"></div>

        {/* Triangle 2 */}
        <div className="absolute bottom-32 left-1/4 w-0 h-0 border-l-[15px] border-r-[15px] border-b-[25px] border-l-transparent border-r-transparent border-b-indigo-500/10 blur-sm"></div>

        {/* Triangle 3 */}
        <div className="absolute top-1/2 right-16 w-0 h-0 border-l-[12px] border-r-[12px] border-b-[20px] border-l-transparent border-r-transparent border-b-purple-500/10 blur-sm"></div>

        {/* Floating Dots */}
        <div className="absolute top-24 right-1/2 w-2 h-2 bg-blue-400/20 rounded-full animate-pulse"></div>
        <div
          className="absolute bottom-40 left-1/3 w-1.5 h-1.5 bg-indigo-400/20 rounded-full animate-pulse"
          style={{ animationDelay: "1s" }}
        ></div>
        <div
          className="absolute top-1/3 left-1/2 w-1 h-1 bg-purple-400/20 rounded-full animate-pulse"
          style={{ animationDelay: "2s" }}
        ></div>

        {/* Gradient Orbs */}
        <div className="absolute top-10 left-1/3 w-32 h-32 bg-gradient-to-r from-blue-500/5 to-purple-500/5 rounded-full blur-2xl"></div>
        <div className="absolute bottom-10 right-1/4 w-28 h-28 bg-gradient-to-r from-indigo-500/5 to-pink-500/5 rounded-full blur-2xl"></div>
      </div>

      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img
                src={image.logoBlack} // Adjust path if needed
                alt="SnapPOS Logo Icon"
                className="w-43 h-10"
              />
            </div>
            <p className="text-gray-400 text-sm">
              Empowering Hospitality & Retail with innovative solutions.
            </p>
            {/* <div className="flex space-x-4">
              <a href="https://github.com/" target="_blank" rel="noopener noreferrer" 
                className="text-gray-400 hover:text-blue-400 transition-colors duration-300 hover:scale-110 transform">
                <GithubOutlined className="text-xl" />
              </a>
              <a href="https://linkedin.com/" target="_blank" rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-400 transition-colors duration-300 hover:scale-110 transform">
                <LinkedinOutlined className="text-xl" />
              </a>
              <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-400 transition-colors duration-300 hover:scale-110 transform">
                <TwitterOutlined className="text-xl" />
              </a>
            </div> */}
          </div>

          {/* About & Features */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">About Us</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/about"
                  className="text-gray-400 hover:text-blue-400 transition-colors duration-300 hover:translate-x-1 transform inline-block"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/features"
                  className="text-gray-400 hover:text-blue-400 transition-colors duration-300 hover:translate-x-1 transform inline-block"
                >
                  Features
                </Link>
              </li>
              {/* <li><Link to="/" className="text-gray-400 hover:text-blue-400 transition-colors duration-300 hover:translate-x-1 transform inline-block">How it works</Link></li> */}
              <li>
                <Link
                  to="/contact"
                  className="text-gray-400 hover:text-blue-400 transition-colors duration-300 hover:translate-x-1 transform inline-block"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Policies</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-gray-400 hover:text-blue-400 transition-colors duration-300 hover:translate-x-1 transform inline-block"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-of-service"
                  className="text-gray-400 hover:text-blue-400 transition-colors duration-300 hover:translate-x-1 transform inline-block"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Subscribe Section */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Subscribe</h3>
            <p className="text-gray-400 mb-4 text-sm">
              Get the latest updates and offers.
            </p>
            <form onSubmit={handleSubscribe} className="space-y-3">
              <div className="relative group">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="w-full px-4 py-2 bg-gray-700/50 backdrop-blur-sm border border-gray-600/50 rounded-lg focus:outline-none focus:border-blue-500 text-gray-200 transition-all duration-300 group-hover:bg-gray-700/70"
                />
                <button
                  type="submit"
                  className="absolute right-2 top-1/2 transform -translate-y-1/2 text-blue-400 hover:text-blue-500 hover:scale-110 transition-all duration-300"
                >
                  <ArrowRightOutlined />
                </button>
              </div>
              <div className="text-xs text-gray-400">
                <Link
                  to="/privacy-policy"
                  className="hover:text-blue-400 transition-colors duration-300"
                >
                  Privacy policy
                </Link>
                {" • "}
                <Link
                  to="/terms-of-service"
                  className="hover:text-blue-400 transition-colors duration-300"
                >
                  Terms of service
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700/50 relative z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              ©2025 Snapposs. All rights reserved.
            </p>
            <p className="text-gray-400 text-sm">
              Designed and Developed by{" "}
              <a
                href="https://www.aakashinfoway.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300 transition-colors duration-300 hover:underline"
              >
                Aakash Infoway Pvt. Ltd.
              </a>
            </p>
          </div>
        </div>
      </div>
    </AntFooter>
  );
};

export default Footer;
